import { Box, type BoxProps } from "@mui/material"

export function Container({ children, sx, ...rest }: BoxProps) {
  return (
    <Box
      component={"header"}
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  )
}
